export default "__VITE_ASSET__CMdSL6gx__"